import { render, staticRenderFns } from "./ArrowUpIcon.vue?vue&type=template&id=af2e60f4"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=js"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports